import React from 'react'
import socketIOClient from 'socket.io-client'
import sailsIOClient from 'sails.io.js'

let io = null

function getIO() {
	if (!io || !io.sails) {
		io = sailsIOClient(socketIOClient)
		// MOVE TO ENVIRONMENT CONFIG!!
		io.sails.url = process.env.REACT_APP_SAILS_URL
		io.sails.environment = process.env.NODE_ENV
		io.sails.reconnection = true
		//io.sails.autoConnect = false
	}
	return io
}

export const APIContext = React.createContext()

export function APIProvider(props) {
	const value = {
		io: props.io || getIO()
	}
	return (
		<APIContext.Provider value={value}>
			{props.children}
		</APIContext.Provider>
	)
}

export function useAPI() {
	return React.useContext(APIContext)
}
